import {
  Cpu,
  BarChart3,
  ShieldCheck,
  CreditCard
} from "lucide-react";

import "../styles/sections.css";

const Features = () => {

  const items = [
    {
      icon:<Cpu size={28}/>,
      title:"AI Dispensing",
      desc:"Automated smart protein serving."
    },
    {
      icon:<BarChart3 size={28}/>,
      title:"Analytics",
      desc:"Real-time machine monitoring."
    },
    {
      icon:<CreditCard size={28}/>,
      title:"Smart Payments",
      desc:"QR, NFC and Apple Pay support."
    },
    {
      icon:<ShieldCheck size={28}/>,
      title:"Cloud Security",
      desc:"Advanced IoT protection system."
    }
  ];

  return (
    <section
      id="features"
      className="features"
    >

      <div className="section-header">

        <span>FEATURES</span>

        <h2>
          Built For Smart Fitness Spaces
        </h2>

      </div>

      <div className="feature-grid">

        {items.map((item,index)=>(
          <div
            className="feature-card"
            key={index}
          >

            <div className="feature-icon">
              {item.icon}
            </div>

            <h3>{item.title}</h3>

            <p>{item.desc}</p>

          </div>
        ))}

      </div>

    </section>
  );
};

export default Features;